import CarHireSearchControls from './SearchControls';

export default CarHireSearchControls;
